var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"allowfullscreen":"","id":"aliyunPreview","frameborder":"0","scrolling":"yes","src":"http://preview.imm.aliyun.com/index.html"}})])
}]

export { render, staticRenderFns }